/* tslint:disable */
import { Section } from "./Section"
import { Question } from "./Question"
import { Decision } from "./Decision"
import { ConditionalBehaviourRule } from "./ConditionalBehaviourRule"
import { ExecutionResult } from "./ExecutionResult"

export class Step {
		FormId: number;
		Order: number;
		InstructionalText: string;
		ExecutionResult: string;
		Id: number;
		Name: string;
		Description: string;

		Sections: Section[];
		Questions: Question[];
		Decisions: Decision[];
		Rules: ConditionalBehaviourRule[];
		ExecutionResults: ExecutionResult[];
}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/Step.ts